export default __webpack_public_path__ + "static/media/ISKO_CLASS-2_SYLLABUS.2c24f047.pdf";